import type { TooltipProps } from "recharts";
import type {
  NameType,
  ValueType,
} from "recharts/types/component/DefaultTooltipContent";

const AreaGraphCustomTooltip = ({
  active,
  payload,
}: TooltipProps<ValueType, NameType>) => {
  if (active && payload && payload.length)
    return (
      <div className="rounded border bg-white p-2 text-black">
        <p className="font-semibold">{payload[0]?.payload.name}</p>
        <p>{payload[0]?.value} €/MWh</p>
      </div>
    );

  return null;
};

export default AreaGraphCustomTooltip;
